
import Sapling from '@/models/sapling.model';
import { GeneticsMapGroup } from '@/services/crossbreeding-service/models';
import { Component, Vue, Prop } from 'vue-property-decorator';
import SaplingGeneRepresentation from './SaplingGeneRepresentation.vue';

@Component({
  components: { SaplingGeneRepresentation }
})
export default class SaplingDetailed extends Vue {
  @Prop({ type: Object, required: true }) readonly sapling!: Sapling;
  @Prop({ type: Object }) readonly saplingVariants?: GeneticsMapGroup;
  @Prop({ type: Boolean }) readonly subtleDetails: boolean;
  @Prop({ type: Boolean }) readonly selectable: boolean;
  @Prop({ type: Boolean }) readonly showGeographicalDirectionTipEast: boolean;
  @Prop({ type: Boolean }) readonly showGeographicalDirectionTipWest: boolean;

  handleSaplingClick() {
    this.$emit('click');
  }
}
